import { render } from "./Login.vue?vue&type=template&id=256bdb23&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=256bdb23&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_confcooperative/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256bdb23"]])

export default __exports__